import { MutationTree } from 'vuex';
import { ApplicationTemplateState, ApplicationTemplate } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../../types';

// エラーをクリアする
const resetErrors = (state: ApplicationTemplateState): void => {
    const indexState = state.index;
    indexState.error = false;
    indexState.errorCode = undefined;
    indexState.errorMsg = undefined;

    const createState = state.create;
    createState.error = false;
    createState.errorTitle = undefined;
    createState.errorDetails = undefined;

    const showState = state.show;
    showState.error = false;
    showState.errorCode = undefined;
    showState.errorMsg = undefined;

    const updateState = state.update;
    updateState.error = false;
    updateState.errorTitle = undefined;
    updateState.errorDetails = undefined;

    const destroyState = state.destroy;
    destroyState.error = false;
    destroyState.errorTitle = undefined;
    destroyState.errorDetails = undefined;
};

export const mutations: MutationTree<ApplicationTemplateState> = {
    // 申請テンプレート一覧系
    [types.INDEX_START](state) {
        resetErrors(state);
        const indexState = state.index;
        indexState.isProcessing = true;
        indexState.isFetchSuccess = false;
    },

    [types.INDEX_SUCCESS](state, payload: { count: number; templates: Array<ApplicationTemplate> }) {
        state.templateCount = payload.count;
        state.templates = payload.templates;

        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = true;
    },

    [types.INDEX_FAILURE](state, payload: { code: string; message: string }) {
        const indexState = state.index;
        indexState.errorCode = payload.code;
        indexState.errorMsg = payload.message;
        indexState.error = true;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;
    },

    // 申請テンプレート作成系
    [types.CREATE_START](state) {
        resetErrors(state);
        const createState = state.create;
        createState.isProcessing = true;
    },

    [types.CREATE_SUCCESS](state) {
        const createState = state.create;
        createState.isProcessing = false;
    },

    [types.CREATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const createState = state.create;
        createState.errorTitle = payload.errorTitle;
        createState.errorDetails = payload.errorDetails;
        createState.error = true;
        createState.isProcessing = false;
    },

    // 申請テンプレート詳細情報参照系
    [types.SHOW_START](state) {
        resetErrors(state);
        const showState = state.show;
        showState.isProcessing = true;
        showState.isFetchSuccess = false;
    },

    [types.SHOW_SUCCESS](state, payload) {
        const showState = state.show;
        state.templateDetails = payload;
        showState.isProcessing = false;
        showState.isFetchSuccess = true;
    },

    [types.SHOW_FAILURE](state, payload: { code: string; message: string }) {
        const showState = state.show;
        showState.errorCode = payload.code;
        showState.errorMsg = payload.message;
        showState.error = true;
        showState.isProcessing = false;
        showState.isFetchSuccess = false;
    },

    // 申請書テンプレート更新系
    [types.UPDATE_START](state) {
        resetErrors(state);
        const updateState = state.update;
        updateState.isProcessing = true;
    },

    [types.UPDATE_SUCCESS](state) {
        const updateState = state.update;
        updateState.isProcessing = false;
    },

    [types.UPDATE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const updateState = state.update;
        updateState.errorTitle = payload.errorTitle;
        updateState.errorDetails = payload.errorDetails;
        updateState.error = true;
        updateState.isProcessing = false;
    },

    // 申請テンプレート削除系
    [types.DESTROY_START](state) {
        resetErrors(state);
        const destroyState = state.destroy;
        destroyState.isProcessing = true;
    },

    [types.DESTROY_SUCCESS](state) {
        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.DESTROY_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const destroyState = state.destroy;
        destroyState.errorTitle = payload.errorTitle;
        destroyState.errorDetails = payload.errorDetails;
        destroyState.error = true;
        destroyState.isProcessing = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const indexState = state.index;
        indexState.isProcessing = false;
        indexState.isFetchSuccess = false;

        const createState = state.create;
        createState.isProcessing = false;

        const showState = state.show;
        showState.isProcessing = false;

        const updateState = state.update;
        updateState.isProcessing = false;

        const destroyState = state.destroy;
        destroyState.isProcessing = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.templates = undefined;
        state.templateCount = 0;
        state.templateDetails = undefined;
    },
};
